import * as React from 'react';
import HotspotImage from './HotspotImage';
import styled from 'styled-components';
import { SwiperSlide } from 'swiper/react';
import Carousel from '../Carousel';

type HotspotProps = {
  hotspot: Elvita.Hotspot;
};

const Hotspot: React.FC<HotspotProps> = ({ hotspot }) => {
  const swiperRef = React.useRef<import('swiper').Swiper | null>(null);

  if (!hotspot) {
    return null;
  }

  return (
    <>
      {hotspot.imageMaps.length > 1 ? (
        <Carousel
          itemsLength={hotspot?.imageMaps.length}
          isStartPage
          className="swiper"
          onSwiperInit={swiper => (swiperRef.current = swiper)}
        >
          {hotspot.imageMaps.map((image, index) => (
            <SwiperSlide
              style={{
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
              }}
              key={index}
            >
              <div>
                <HotspotImage
                  image={image}
                  slideIndex={index}
                  swiperRef={swiperRef}
                  key={index}
                />
              </div>
            </SwiperSlide>
          ))}
        </Carousel>
      ) : (
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <HotspotImage image={hotspot.imageMaps[0]} />
        </div>
      )}
    </>
  );
};

export default Hotspot;
